(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/prescript.js');

'use strict';

svs = svs || {};
svs.tt = svs.tt || {};
svs.tt.components = svs.tt.components || {};
svs.tt.hooks = svs.tt.hooks || {};
svs.tt.services = svs.tt.services || {};
svs.tt.utils = svs.tt.utils || {};


 })(window);